export default function(selector, element) {
  while ((element = element.parentElement) && ! element.classList.contains(selector));

  return element;
}



/** WEBPACK FOOTER **
 ** ./assets/js/lib/find-closest.js
 **/